import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss, toastSuccesssLong } from "../../Helper/ToastMessage";
import moment from "moment";


// Get Table Data
export const Get_A_Report_Execution_SelectDataAPI = createAsyncThunk("Get_A_Report_Execution_SelectData", async ({ data }) => {
    const {
        UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_A_Report_Execution_Select?M_UsersID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result?.data?.table) {
                return result?.data?.table
            } else {
                return result
            }
        })
})

const Get_A_Report_Execution_SelectDataSlice = createSlice({
    name: "Get_A_Report_Execution_SelectData",
    initialState: {
        isLoading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_A_Report_Execution_SelectDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_A_Report_Execution_SelectDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.TableData = action.payload;
        });
        builder.addCase(Get_A_Report_Execution_SelectDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.TableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_A_Report_Execution_SelectDataReducer = Get_A_Report_Execution_SelectDataSlice.reducer


// InsertUpdate Table Data

export const Post_A_Report_Execution_InsertDataAPI = createAsyncThunk("Post_A_Report_Execution_InsertData", async ({ data }) => {
    const {
        setloading,
        CurrentDate,
        M_UserID,
        token,
        Flag,
        handleIsPost
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("CurrentDate", CurrentDate);
    formdata.append("Flag", Flag);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setloading(true)
    fetch(`${BaseUrl}/APKDashboard/Post_A_Report_Execution_Insert`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost(CurrentDate)
                setloading(false)
                toastSuccesssLong(moment(CurrentDate).format('DD-MM-YYYY'), result.message)
                return result.data
            } else {
                handleIsPost('Error')
                toastErrorr(result.message)
                setloading(false)
            }
            return result
        })
})

const Post_A_Report_Execution_InsertDataSlice = createSlice({
    name: "Post_A_Report_Execution_InsertData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Post_A_Report_Execution_InsertDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Post_A_Report_Execution_InsertDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Post_A_Report_Execution_InsertDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const Post_A_Report_Execution_InsertDataReducer = Post_A_Report_Execution_InsertDataSlice.reducer


export const Post_A_Report_Execution_InsertDataAPI1 = createAsyncThunk(
    "Post_A_Report_Execution_InsertData",
    async ({ data }) => {
        const {
            setloading,
            CurrentDate,
            M_UserID,
            token,
            Flag,
            handleIsPost,
        } = data;

        try {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", "Bearer " + token);

            var formdata = new FormData();
            formdata.append("CurrentDate", CurrentDate);
            formdata.append("Flag", Flag);
            formdata.append("M_UserID", M_UserID);

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow",
            };

            setloading(true);
            const res = await fetch(
                `${BaseUrl}/APKDashboard/Post_A_Report_Execution_Insert`,
                requestOptions
            );
            const result = await res.json();

            setloading(false);

            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost(CurrentDate);
                toastSuccesssLong(
                    moment(CurrentDate).format("DD-MM-YYYY"),
                    result.message
                );
                return result;
            } else {
                handleIsPost("Error");
                toastErrorr(result.message);
                throw new Error(result.message || "API Error");
            }
        } catch (error) {
            setloading(false);
            console.error("API call error:", error);
            throw error;
        }
    }
);


export const Get_A_Report_Execution_Project_Wise_Date_SelectDataAPI = createAsyncThunk("Get_A_Report_Execution_Project_Wise_Date_SelectData", async ({ data }) => {
    const {
        M_ProjectTypeID,
        M_FinancialYearID,
        M_MonthID,
        M_UsersID,
        token,
        setTableModalData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_A_Report_Execution_Project_Wise_Date_Select?M_ProjectTypeID=${M_ProjectTypeID}&M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_UsersID=${M_UsersID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result?.data?.table) {
                setTableModalData && setTableModalData(result?.data?.table)
                return result?.data?.table
            } else {
                setTableModalData && setTableModalData([])
                return result
            }
        })
})

const Get_A_Report_Execution_Project_Wise_Date_SelectDataSlice = createSlice({
    name: "Get_A_Report_Execution_Project_Wise_Date_SelectData",
    initialState: {
        isLoading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_A_Report_Execution_Project_Wise_Date_SelectDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_A_Report_Execution_Project_Wise_Date_SelectDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.TableData = action.payload;
        });
        builder.addCase(Get_A_Report_Execution_Project_Wise_Date_SelectDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.TableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_A_Report_Execution_Project_Wise_Date_SelectDataReducer = Get_A_Report_Execution_Project_Wise_Date_SelectDataSlice.reducer





// Get Table Data
export const Get_Piller_Current_RatingDataAPI = createAsyncThunk("Get_Piller_Current_RatingData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        M_Ward_Wise_VendorID,
        M_WardID,
        token,
        setPDFUrl
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_Piller_Current_Rating?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_WardID=${M_WardID}&M_Ward_Wise_VendorID=${M_Ward_Wise_VendorID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                setPDFUrl && setPDFUrl(result?.url)
                if (result?.data && result?.data?.length > 0) {
                    return result?.data
                } else {
                    toastSuccesss(result?.message)
                }
            } else {
                return result
            }
        })
})

const Get_Piller_Current_RatingDataSlice = createSlice({
    name: "Get_Piller_Current_RatingData",
    initialState: {
        isLoading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_Piller_Current_RatingDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_Piller_Current_RatingDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.TableData = action.payload;
        });
        builder.addCase(Get_Piller_Current_RatingDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.TableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_Piller_Current_RatingDataReducer = Get_Piller_Current_RatingDataSlice.reducer
